<template>
    <div>
        <div v-html="private_content"></div>
        <!-- <p>欢迎您使用企讯客（以下简称“本应用”）。我们重视您的隐私并致力于保护您的个人数据。本隐私政策旨在帮助您了解我们如何收集、使用、存储和分享您在使用本应用时提供给我们的信息，以及您对这些信息的控制权。<br /></p>
        <h3>收集的信息</h3>
        <h4>设备权限与信息类型</h4>
        <p>在您使用本应用的过程中，我们可能会请求访问您的设备上的某些权限，以便为您提供更好的服务和体验。以下是具体的权限说明及其用途：</p>
        <p><strong>相机权限</strong> :
            我们会请求访问您的设备相机，目的是为了进行用户身份识别（如面部识别），以确保账户的安全性和提供个性化的服务。此功能仅在您明确同意的情况下启动，并且不会在未经您许可的情况下使用相机进行其他活动。</p>
        <p><strong>自动对焦功能</strong> : 如果您的设备支持自动对焦功能，本应用可能会使用此功能来提高照片质量和视频清晰度。</p>
        <p><strong>位置信息</strong> : 为了提供基于位置的服务，如附近搜索等功能，我们可能会请求访问您的设备的位置信息。您可以选择是否提供精确位置（GPS）或大致位置（基于网络）。</p>
        <p><strong>网络状态</strong> : 我们会检查您的网络连接状态，以便优化应用性能或提供离线模式下的功能。</p>
        <p><strong>蓝牙权限</strong> : 使用本应用切换蓝牙、听筒或扬声器的播放模式，我们需要访问蓝牙功能。这将允许用户根据自己的偏好选择最合适的音频输出方式。</p>
        <p><strong>拨打电话权限</strong> : 作为本应用的核心功能之一，我们请求拨打电话的权限是为了允许用户通过本应用进行电话拨打，并记录拨打历史。这使得用户能够在应用内部管理其拨打记录。</p>
        <p><strong>更改网络状态</strong> : 为了更好地管理网络连接，应用可能会请求更改网络或Wi-Fi状态的权限。</p>
        <p><strong>手电筒权限</strong> : 应用具有照明功能，我们可能需要访问设备的手电筒。</p>
        <p><strong>账户权限</strong> : 为了提供账户同步服务或其他账户相关的功能，我们可能需要访问您的设备账户信息。</p>
        <p><strong>互联网权限</strong> : 为了提供在线服务和功能，我们需要访问互联网。</p>
        <p><strong>音频设置</strong> : 为了优化音频输出，本应用可能会请求修改音频设置的权限。</p>
        <p><strong>文件系统权限</strong> : 应用可能需要挂载或卸载文件系统来进行数据管理。</p>
        <p><strong>通话记录权限</strong> : 如果应用涉及通话记录的功能，我们可能需要读取或写入您的通话记录。</p>
        <p><strong>联系人权限</strong> : 为了方便您在应用中添加联系人或分享信息给好友，我们可能需要读取或写入您的联系人信息。</p>
        <p><strong>外部存储权限</strong> : 为了保存或加载文件，我们需要访问您的设备存储空间。</p>
        <p><strong>日志信息</strong> : 本应用可能会读取设备的日志文件，以帮助诊断问题或改善服务。</p>
        <p><strong>电话状态权限</strong> : 为了提供更好的服务和支持，我们可能会读取您的电话状态，包括设备标识符。</p>
        <p><strong>短信权限</strong> : 如果应用需要处理短信功能，我们可能需要读取您的短信。</p>
        <p><strong>录音权限</strong> : 应用包含录音功能，我们可能需要访问麦克风。</p>
        <p><strong>震动权限</strong> : 为了提供振动反馈，本应用可能需要访问设备的振动功能。</p>
        <p><strong>唤醒锁权限</strong> : 应用可能会保持设备屏幕常亮，以确保在执行关键任务时不被屏幕关闭影响。</p>
        <p><strong>系统设置权限</strong> : 如果应用需要更改系统设置，如音量或壁纸，它可能需要此权限。</p>
        <hr />
        <h3>如何使用您的信息</h3>
        <p>我们收集的信息可能用于以下几个方面：</p>
        <p><span style="font-size: 14px;">提供、维护和改进本应用的服务和功能。</span></p>
        <p><span style="font-size: 14px;">用户身份验证、客户服务支持，以及回应您的查询和需求。</span></p>
        <p><span style="font-size: 14px;">开展研究和分析，以改善用户体验。</span></p>
        <p><span style="font-size: 14px;">提供个性化的内容和广告。</span></p>
        <p><span style="font-size: 14px;">法律合规目的，包括遵守适用的法律、法规、法院命令或政府要求。</span></p>
        <hr />
        <h3>联系我们</h3>
        <p>如果您对本隐私政策有任何疑问或需要进一步的帮助，请通过以下方式与我们联系：</p>
        <p>电子邮件：[<b>182316127@qq.com</b>]<br />电话：[<b>18181096464</b>]&nbsp;</p> -->
    </div>
</template>
<script>
import { appConfigPub } from '@/api/app'
export default {
    data(){
        return {
            private_content:''
        }
    },
    created(){
        this.getAppConfig()
    },
    methods:{
        async getAppConfig(){
            const res = await appConfigPub()
            if(res.code == 1){
                this.private_content = res.data.private_content
            }
        }
    }
}
</script>